/* eslint-disable @next/next/no-img-element */
import http from 'utilities/http';
import dayjs from "dayjs";
import SliderAd from "components/chuyen-gia/slider";
import {getTypeArticle, inArraySlug, numberWithCommas} from "utilities/helper";
import Comment from "components/cong-dong/comment";
import {getCookie} from "framework/libs/cookie";
import {TOKEN_CONGDONG} from "framework/store/constants";
import {DOMAIN_API_URL_V2, DOMAIN_HAPPYNEST, SLUG_LIST} from "utilities/constants";
import Image from "next/image";
import Slider from 'react-slick';
import {isEmpty, isArray, isObject} from 'lodash';
import {useEffect, useRef, useState} from "react";
import {toast} from 'react-toastify';
import Share from "components/share";
import {useRouter} from "next/router";
import ImageComponentWithTag from 'components/cong-dong/chi-tiet/imageComponentWithTag';
import {replaceAll} from 'utilities/helper';
import parse, {domToReact} from 'html-react-parser';
import {useCart} from "framework/store";
import Head from "next/head";
import ModalProduct from 'components/cong-dong/chi-tiet/modalProducts';
import {formatSku} from 'utilities/helper';
import ModalConfirm from "components/modal/modalConfirm";
import HomeStory from "components/cong-dong/home-story";
import ImageStore from "components/cong-dong/imageStore";
import ProfessionalInfo from 'components/cong-dong/chi-tiet/professionalInfo';
import Poll from "components/cong-dong/poll";
import StarList from "components/shop/review/starList";
import ArticleInfo from "components/cong-dong/chi-tiet/articleInfo";
import {getUrlName} from 'utilities/helper';
import RelatedPost from 'components/cong-dong/relatedPost';
import * as ReactDOMServer from 'react-dom/server';
import FormDangKyTuVan from 'components/don-tu-van/formDangKyTuVan.js';
import Slide from "components/layout/slide-arrow.js";
import Detail360 from 'components/cong-dong/kho360';
import {PostSchema} from "../schemas/PostSchema";
import ButtonModalDonTuVan from 'components/don-tu-van/buttonModalDonTuVan';
import {insider_view_bai_viet_chi_tiet} from 'utilities/insider-events';
import {Modal} from 'antd';
import {Loader} from 'components/loader';
import {isStaging} from 'utilities/api';

export const ARTICLE = 2;
export const PHOTO = 3;
export const THREAD = 4;
export const FAQ = 5;
export const ALBUM = 6;
export const renderTypePost = (slug = "") => {
    if (slug === "eMagazine" || slug === "emagazine") {
        return "happynest-story";
    }
    if (slug === "" || slug === null) {
        return "chuyen-nha";
    }
    if (slug === "kho-anh") {
        return "album";
    }
    if (slug === "thread") {
        return "thao-luan";
    }
    return slug;
};
export const renderByType = (category, name) => {
    if (isEmpty(category)) return;

    const data = category.items?.data || [];
    const type = name || category.name;

    if (isEmpty(data)) return <></>;

    switch (type) {
    case 'Chuyện nhà':
        return <HomeStory title={type} items={data} perRow={2}/>;
    case 'Kho ảnh':
        return <ImageStore title={type} item={data} slug='album' perRow={2}/>;
    case 'Thảo luận':
        return <HomeStory title={type} slug="thao-luan" items={data} perRow={2}/>;
    case 'Chợ đồ cũ':
        return <HomeStory title={type} slug="cho-do-cu" items={data} perRow={2}/>;
        ;
    case 'Review':
        return <HomeStory title={type} slug="review" items={data} perRow={2}/>;
        ;
    case 'Sự kiện':
        return <HomeStory title={type} slug="su-kien" items={data} perRow={2}/>;
        ;
    case 'HappynestTV':
        return <HomeStory title={type} slug="happynesttv" items={data} perRow={2}/>;
    case 'Kho 360': {
        const items = data.map((item, index) => {
            return <Detail360 key={index} item={item} index={index} isSlide={true}/>;
        });
        return <div className="bb-sp home-story">
            <div className="groupCategory-title mb-0">
                <h2 className="groupCategory-tlt">{type}</h2>
                <a href="/kho-360" className="readMore">Xem tất cả</a>
            </div>
            <div key="kho-360" className="lstPhoto category-list">
                <Slide items={items} slidesToShow={4} className="mt-3"/>
            </div>
        </div>;
    }
    default:
        return <HomeStory title={type} items={data} perRow={2}/>;
    }
};

const contentType = (slug) => {
    let contentType = 'article';
    switch (slug) {
    case 'kho-anh':
        contentType = 'album';
        break;
    case 'album':
        contentType = 'album';
        break;
    case 'thao-luan':
        contentType = 'thread';
        break;
    case 'chuyen-gia':
        contentType = 'professional';
        break;
    }
    return contentType;
};

export default function ProductPage({path, article: articleSSG, addPreview = ""}) {
    const router = useRouter();


    const slug = contentType(path[0]);
    const typeArticle = path[0];
    const idArticle = path[1];
    const [stateStore, actions] = useCart();
    const [article, setArticle] = useState(articleSSG);
    const [theoDoi, setTheoDoi] = useState(false);
    const [likeStatus, setLikeStatus] = useState(false);
    const [articleLikeCount, setArticleLikeCount] = useState(0);
    const [pinsStatus, setPinsStatus] = useState(false);
    const [pinsCount, setPinsCount] = useState(0);
    const [authorAlbum, setAuthorAlbum] = useState([]);
    const [hotProduct, setHotProduct] = useState([]);

    // useEffect(() => {
    //     if (!articleSSG.title && articleSSG?.album?.id) {
    //         router.push(`/album/${articleSSG.album.id}/${getUrlName(articleSSG.album.title)}`);
    //     }
    //     if (SLUG_LIST.every(x => x.slug != articleSSG.first_term?.slug)) return;
    //
    //     if (path[0] != 'album' && path[0] != articleSSG.first_term?.slug) {
    //         router.push(`/${articleSSG.first_term?.slug}/${articleSSG.id}/${articleSSG.slug}`);
    //     }
    //     if (path[0] == 'album' && articleSSG.first_term?.slug != 'kho-anh') {
    //         router.push(`/${articleSSG.first_term?.slug}/${articleSSG.id}/${articleSSG.slug}`);
    //     }
    //
    // }, [router]);

    //share
    const [onShare, setOnShare] = useState(false);
    const fetchArticle = async () => {
        try {
            let url = `community/${slug}/${idArticle}${addPreview}`;
            if (!isEmpty(router) && typeof router?.query.site_url != "undefined") {
                url = `community/${slug}/${idArticle}${addPreview}?site_url=${router.query.site_url}`;
            }

            const res1 = await http(url, {}, {token: "Bearer " + getCookie(TOKEN_CONGDONG)}, 'v2');
            if (res1.code == 200) {
                setArticle(res1?.data || []);
                setLikeStatus(res1?.data?.current_user_liked);
                setPinsStatus(res1?.data?.current_user_pinned);
                setTheoDoi(res1?.data?.user.is_followed);
            }
            ;
        } catch (e) {
            console.log(e);
        }
    };

    const fetchAuthorAlbum = async (id) => {
        const res2 = await http(`user/${id}/albums?page=1`, null, {token: 'Bearer ' + getCookie(TOKEN_CONGDONG)}, 'v2');
        const imageList = [];
        (res2?.data || []).forEach((photo, index) => {
            (photo.images?.data || []).forEach(image => {
                imageList.push(image);
            });
        });
        setAuthorAlbum(imageList);
    };

    const fetchHotProduct = async () => {
        const hotProductsParams = {
            filters: [[{
                field: 'status',
                value: 1,
                condition_type: 'eq'
            }]],
            size: 4,
        };
        const res = await http('/rest/default/V1/products', hotProductsParams, {token: 'default'});
        setHotProduct(res?.items || []);
    };

    useEffect(() => {
        if (articleSSG.id == article.id) return;
        setArticle(articleSSG);
    }, [articleSSG]);

    useEffect(() => {
        fetchArticle();
        // fetchHotProduct();
    }, [path, router]);
    const slugCategory = renderTypePost(slug);

    let slugCategorySSR = articleSSG.first_term?.slug;
    console.log({
        slugCategorySSR:slugCategorySSR
    });
    if(articleSSG.first_term === null){
        slugCategorySSR = slugCategory;
    }
    if(slugCategorySSR === "kho-anh"){
        slugCategorySSR = "album";
    }
    if (slugCategorySSR === "eMagazine" || slugCategorySSR === "emagazine") {
        slugCategorySSR =  "happynest-story";
    }
    if(slugCategorySSR === "thread"){
        slugCategorySSR = "thao-luan";
    }
    if(articleSSG.first_term?.parent_id > 0){
        slugCategorySSR = getTypeArticle(articleSSG);
    }
    if(typeof slugCategorySSR === "undefined"){
        slugCategorySSR = slugCategory;
    }
    let seoUrl = DOMAIN_HAPPYNEST + slugCategorySSR + '/' + articleSSG.id + '/' + articleSSG.slug;
    console.log("SEO: "+seoUrl);
    useEffect(() => {
        if (isEmpty(article)) return;
        // console.log(slugCategory, slugArticle, slugCategorySSR,article,inArraySlug(slugCategory));
        // if (slugCategory !== slugArticle && slugCategory !== slugCategorySSR && !inArraySlug(slugCategory)) {
        //     router.push(seoUrl);
        // }
        setArticleLikeCount(article.interaction_count?.like_count_number);
        setPinsCount(article.interaction_count?.pin_count_number);
    }, [article, router]);

    useEffect(() => {
        fetchAuthorAlbum(article.user?.id);
    }, []);

    useEffect(() => {
        try {
            const data = {
                title: articleSSG.title,
                category_ids: [],
                category_names: [],
                category_slugs: [],
                tag_ids: [],
                tag_names: [],
                tag_slugs: [],
                author_id: articleSSG?.user?.id,
                author_name: articleSSG?.user?.display_name,
                post_id: articleSSG.id,
                post_type: articleSSG.post_type,
                post_type_id: articleSSG.post_type_id,
                post_slug: articleSSG.slug,
            };
            (articleSSG.all_terms?.data || []).forEach(term => {
                data.category_ids.push(term.id);
                data.category_names.push(term.name);
                data.category_slugs.push(term.slug);
            });

            (articleSSG.tags?.data || []).forEach(tag => {
                data.tag_ids.push(tag.id);
                data.tag_names.push(tag.name);
                data.tag_slugs.push(tag.slug);
            });

            insider_view_bai_viet_chi_tiet(data);
            window.insider_object = window.insider_object || {};
            window.insider_object.page = data;
        } catch (e) {
            console.log(e);
        }

    }, []);

    const createMarkup1 = () => {
        let des = article.content || article.description;
        des = replaceAll(des, '<img', '<img id="main" height= "auto"');
        des = replaceAll(des, '<a', '<a target="_blank"');
        des = replaceAll(des, '\n', '');
        des = replaceAll(des, '&nbsp;', '');
        des = replaceAll(des, '<Chuyện', '&#60;Chuyện');
        const options = {
            replace: ({attribs, children}) => {
                if (!attribs) {
                    return;
                }
                if (isArray(children) && children.some(x => x.name == 'img')) {
                    return <>{domToReact(children, options)}</>;
                }
                if (attribs.download) {
                    return <DownloadFile text={children[0].data} id={attribs.href}/>;
                }
                if (!attribs.src) return;
                const index = article?.images?.data.findIndex(x => x.storage_url.indexOf(attribs.src.substring(17)) >= 0);
                if (index >= 0) {
                    const image = article?.images?.data[index];
                    return <div className="createPost-thumb">
                        <div className="thumb sliderPhoto" style={{position: 'relative'}}>
                            {index == 3 &&
                                <SliderAd positionDesktop="12" pageDesktop="59" positionMobile="14" pageMobile="59"/>}
                            <ImageComponentWithTag image={image} isOwn={isOwn}></ImageComponentWithTag>
                        </div>
                    </div>;
                }
            }
        };
        return parse(des, options);
    };

    const settingsDetail1 = {
        infinite: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                }
            }
        ]
    };

    const information = {};
    if (isArray(article.information)) {
        article.information.forEach(info => {
            const infoHouse = Object.entries(info)[0];
            if (infoHouse[0] == 'constructor') infoHouse[0] = 'constructorApi';
            information[infoHouse[0]] = infoHouse[1];
        });
    }

    if (isObject(article.information)) {
        Object.values(article.information).forEach(info => {
            const infoHouse = Object.entries(info)[0];
            if (infoHouse[0] == 'constructor') infoHouse[0] = 'constructorApi';
            information[infoHouse[0]] = infoHouse[1];
        });
    }
    const actionBack = () => {
        if (!isEmpty(router) && typeof router?.query.site_url != "undefined") {
            return `/sites/${router?.query.site_url}`;
        }
        return "/";
    };
    const actionLike = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập để thao tác.');
            return;
        }

        const res = await http(`community/${slug}/likes/toggle`, {}, {
            body: {id: `${article?.id}`},
            method: 'POST',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res.code == 200) {
            setLikeStatus(res?.toggle == "on" ? true : false);
            setArticleLikeCount(res?.interaction_count);
        } else {
            if (res.code == 401) {
                toast.info('Bạn cần đăng nhập để thao tác.');
            }
        }
    };
    const actionPins = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập để thao tác.');
            return;
        }

        const res = await http(`community/${slug}/pins/toggle`, {}, {
            body: {id: `${article?.id}`},
            method: 'POST',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res.code == 200) {
            setPinsStatus(res?.toggle == "on" ? true : false);
            setPinsCount(res?.interaction_count);
        } else {
            if (res.code == 401) {
                toast.info('Bạn cần đăng nhập để thao tác.');
            }
        }
    };
    const handleTheoDoi = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập để thao tác.');
            return;
        }

        const res = await http(`community/professional/follows/toggle`, {}, {
            body: {id: article.user.id},
            method: 'POST',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res.code === 200) {
            setTheoDoi(!theoDoi);
        }
    };

    const genReviewSanPham = () => {
        if (article.reviewer_type != 2) return <></>;
        if (isEmpty(article.review_data)) return <></>;
        const product = {};
        article.review_data.forEach(x => Object.assign(product, x));

        return <div className="detail-evaluate">
            <p className="tlt">Đánh giá sản phẩm</p>
            <a href={product.url || '#'} style={!product.id ? {pointerEvents: 'none'} : {}}>
                <div className="photoStore-head">
                    {product.image && <div className="photoStore-head__item" style={{borderRadius: 10}}>
                        <img alt="" src={product.image || '/images/icon-app.svg'}/>
                    </div>}
                    <div className={product.image ? "photoStore-head__text" : "photoStore-head__text pl-0"}>
                        <p className="tlt">{product.name}</p>
                        {/* <p className="lable">{article.review_data?.infoProfessional}</p> */}
                    </div>
                </div>
            </a>

            <p className="text-level">Mức độ hài lòng với sản phẩm</p>
            <StarList number={article.rating} size={25}/>
            <p className="review-article">Bài viết đánh giá</p>
        </div>;
    };

    const genReviewChuyenGia = () => {
        if (article.reviewer_type != 1) return <></>;

        return <div className="detail-evaluate">
            <p className="tlt">Đánh giá chuyên gia</p>
            <a href={`/thanh-vien/u/${article.review_data?.id}?t=tong-quan`}>
                <div className="photoStore-head">
                    <div className="photoStore-head__item">
                        <img alt="" src={article.review_data?.avatar || '/images/icon-app.svg'}/>
                    </div>
                    <div className="photoStore-head__text">
                        <p className="tlt">{article.review_data?.display_name}</p>
                        <p className="lable">{article.review_data?.infoProfessional}</p>
                    </div>
                </div>
            </a>

            <p className="text-level">Mức độ hài lòng với chuyên gia</p>
            <StarList number={article.rating} size={25}/>
            <p className="review-article">Bài viết đánh giá</p>
        </div>;
    };

    const isOwn = stateStore.profileCommunity?.id === article?.user?.id;

    const getUrlChinhSuaBai = () => {
        let url = '';

        if (article.post_type_id == 2) url = `/tao-bai-viet/1/chuyen-nha/${article?.id}`;
        if (article.post_type_id == 6) url = `/tao-bai-viet/1/album/${article?.id}`;
        if (article.post_type_id == 4) url = `/tao-bai-viet/1/thao-luan/${article?.id}`;
        if (typeArticle === 'cho-do-cu') url = `/tao-bai-viet/1/cho-do-cu/${article?.id}`;
        if (article.reviewer_type == 2) url = `/tao-bai-viet/1/review-san-pham/${article?.id}`;
        if (article.reviewer_type == 1) url = `/tao-bai-viet/1/review-chuyen-gia/${article?.id}`;
        if (article.all_terms?.data.some(x => x.id == 301)) url = `/tao-bai-viet/1/an-choi/${article?.id}`;

        return url;
    };

    const xoaBai = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập để thao tác.');
            return;
        }

        const res = await http(`community/${slug}/${article?.id}`, {}, {
            method: 'DELETE',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res.code == 200) {
            router.push('/');
            toast.info('Xóa bài thành công!');
        } else {
            if (res.code == 401) {
                toast.info('Bạn cần đăng nhập để thao tác.');
            } else {
                toast.error(res.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
                router.reload();
            }
        }
    };

    const toolView = <div className={"toolsView " + (article.storage_emagazine_url ? 'mt-3' : '')}
        style={{zIndex: 100}}>
        <div className='toolsView-div'>
            <ul>
                <li>
                    <a href={actionBack()} className="item item-back">
                        <img alt="" src={"/images/Back.svg"}/>
                    </a>
                </li>
                <li>
                    <span className="item item-heart">
                        <img alt="" src={likeStatus ? "/images/icon-heart.svg" : "/images/icon-heart01.svg"}
                            onClick={() => actionLike()}/>
                    </span>
                    <span
                        className="toolsView-number">{numberWithCommas(articleLikeCount || 0)}</span>
                </li>
                <li>
                    <span className="item item-bookmark">
                        <img alt="" className="svg"
                            src={pinsStatus ? "/images/icon-bookmark03.svg" : "/images/icon-bookmark02.svg"}
                            onClick={() => actionPins()}/>
                    </span>
                    <span
                        className="toolsView-number">{numberWithCommas(pinsCount || 0)}</span>
                </li>
                <li>
                    <a className="item item-comment" href="#comments"><img alt="" className="svg"
                        src="/images/icon-comment.svg"/></a>
                    <span
                        className="toolsView-number">{numberWithCommas(article.interaction_count?.comment_count_number || 0)}</span>
                </li>
                <li>
                    <span className="item item-share dropdown">
                        <img alt="" data-toggle="dropdown" className="svg" src="/images/icon-share01.svg"
                            onClick={() => {
                                setOnShare(!onShare);
                            }}/>
                    </span>
                    <span
                        className="toolsView-number">{numberWithCommas(article.interaction_count?.share_count_number || 0)}</span>
                </li>
            </ul>
            <ModalProduct images={article.images?.data}/>
            {
                article.is_consulting && <>
                    <div className='pc-only'>
                        <ButtonModalDonTuVan article={article} chuyenGia={article.consultant_id ? {
                            id: article.consultant_id,
                            display_name: article.consultant_name
                        } : null} source={5}/>
                    </div>
                </>
            }
            {isOwn && getUrlChinhSuaBai() && <div className='btnEdit'>
                <button type="button" className="btn btn-outline-white "
                    onClick={() => router.push(getUrlChinhSuaBai())}>Sửa bài
                </button>
            </div>}
            {isOwn && <div className='btnEdit'>
                <ModalConfirm text="Xóa" classes="btn btn-outline-white btnEdit" title="Thông báo"
                    content="Bạn chắc rằng mình sẽ xóa bài này?" callback={xoaBai}/>
            </div>}
        </div>
    </div>;

    const authorHorizon = <div className={!isEmpty(authorAlbum) ? "photoFollow" : "photoFollow pb-2"}>
        <div className="photoStoreDetail-head">
            <div className="photoStore-head" style={{cursor: 'pointer'}}>
                <div className="photoStore-head__item">
                    <a href={`/thanh-vien/u/${article.user?.id}?t=tong-quan`}>
                        <Image width={48} height={48} src={article?.user?.avatar || "/images/icon-app.svg"}
                            alt=""></Image>
                    </a>
                </div>
                <div className="photoStore-head__text">
                    <p className="tlt">
                        {article?.user?.display_name}
                        {stateStore.profileCommunity?.id !== article?.user?.id &&
                            <a onClick={handleTheoDoi}
                                style={{cursor: 'pointer'}}>{theoDoi ? 'Đang theo dõi' : 'Theo dõi'}</a>}
                    </p>
                    <a href={`/thanh-vien/u/${article.user?.id}?t=tong-quan`}>
                        {(article.user?.is_professional || article.user?.id == 18) &&
                            <p className="lable">{article.user?.infoProfessional}</p>}
                    </a>
                </div>
            </div>
        </div>
        {!isEmpty(authorAlbum) && <div className="slider slider-thumbFollow">
            <Slider {...settingsDetail1}>
                {(authorAlbum || []).map((x, index) => (
                    <div key={index} className="thumbFollow wrap-next-image">
                        <Image width={96} height={96} alt="" src={x?.storage_url}/>
                    </div>
                ))}
            </Slider>
        </div>}
        {Boolean(article?.user?.rating > 0) && <div className="photoFollow-view">
            {Boolean(article?.user?.rating > 0) && <span className="view">{article?.user?.rating}
                <img alt="" src="/images/icon-star.svg"/>
            </span>}
            {/* <span className="number">{article?.user?.total_rating} dự án • {article?.user?.total_articles} sản phẩm</span> */}
            <span className="maps"><img alt=""
                src="/images/icon-maps.svg"/> {article?.user?.address || article?.user?.location}</span>
        </div>}
    </div>;

    const [seeMore, setSeeMore] = useState(false);

    const createMarkup2 = () => {
        if (articleSSG.livestream_embedded) {
            let des = articleSSG.livestream_embedded;
            const options = {
                replace: ({attribs, children}) => {
                    if (!attribs) {
                        return;
                    }
                    return <iframe src={attribs.src} allowFullScreen={true} allow={attribs.allow}></iframe>;
                }
            };
            return parse(des, options);
        }
    };
    const schema = new PostSchema(articleSSG);
    const renderSchema = schema.init();
    const [height, setHeight] = useState("100vh");
    const iframeRef = useRef(null);
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.height) {
                setHeight(`${event.data.height}px`);
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);
    const urlIframe = DOMAIN_API_URL_V2+'get-html?url='+article.storage_emagazine_url;
    return (
        <>
            <Head>
                {articleSSG.seo?.title && <title>{articleSSG.seo.title}</title>}
                {articleSSG.seo?.title && <meta property="og:title" content={articleSSG.seo.title} key="title"/>}
                {articleSSG.seo?.description &&
                    <meta name="description" content={articleSSG.seo.description} key="description"/>}
                {articleSSG.seo?.description &&
                    <meta property="og:description" content={articleSSG.seo.description} key="og:description"/>}
                {articleSSG.seo?.keywords &&
                    <meta name="keywords" content={articleSSG.seo.keywords}/>}
                {<meta property="og:image"
                    content={article.storage_thumbnail_url_wide || article.storage_thumbnail_url || article.storage_thumbnail_url_large || (article.images?.data && article.images?.data[0]?.storage_url)}/>}
                {articleSSG.seo?.title && <meta property="og:url" content={seoUrl} key="og:url"/>}
                {<link rel="canonical" href={seoUrl}/>}
                {<meta property="og:type" content="article" key="og:type"/>}
                {<meta property="fb:app_id" content="984476728630070" key="fb:app_id"/>}
                {
                    renderSchema.map((item, index) => {
                        return <script type="application/ld+json" key={index} dangerouslySetInnerHTML={{
                            __html: JSON.stringify(item)
                        }}></script>;
                    })
                }
            </Head>

            {
                article.storage_emagazine_url && <>
                    <section className="main main--photoStoreDetail pt-0 position-relative">
                        <iframe
                            ref={iframeRef}
                            src={urlIframe} width="100%"
                            className='emagazine-frame'
                            style={{
                                width: "100%",
                                height: height,
                                border: "none",
                                overflow: "hidden",
                            }}
                        />
                        <div className="wrap">
                            <div className={"photoStoreDetail"}>
                                {toolView}
                                <Share onShare={onShare} setOnShare={setOnShare} url={router.asPath} id={articleSSG.id}/>
                                <Comment article={article} slug={slug}/>

                                <SliderAd positionDesktop="2" pageDesktop="59" positionMobile="6" pageMobile="59"/>

                                {
                                    <HomeStory title={'Bài đăng liên quan'} author={false} slug='happynest-story'
                                        items={(article.related_posts?.data || []).filter(x => x.storage_emagazine_url)}
                                        perRow={2} no/>
                                }
                            </div>
                        </div>
                    </section>
                </>
            }

            {!article.storage_emagazine_url && <section className="main main--photoStoreDetail">
                <Share onShare={onShare} setOnShare={setOnShare} url={router.asPath} id={articleSSG.id}/>
                <SliderAd positionMobile="24" pageMobile="59" isPopup={true}/>
                <div className="wrap">
                    {
                        (article.storage_thumbnail_url_large != 'https://happynest.vn/home2017-assets/images/avatar-happynest@2x.jpg'
                            && article.post_type_id != 3
                            && article.post_type_id != 6
                            && article.post_type_id != 4
                            && article.post_type != 'video'
                            && path[0] != 'happynesttv'
                            && path[0] != 'kho-360'
                            && typeArticle !== 'cho-do-cu')
                        && <div className="thumbDetail wrap-next-image">
                            <img alt="" src={article.storage_thumbnail_url_large}/>
                        </div>
                    }
                    {
                        (article.storage_thumbnail_url_large === 'https://happynest.vn/home2017-assets/images/avatar-happynest@2x.jpg'
                            && !isEmpty(article.images?.data)
                            && article.post_type_id != 3
                            && article.post_type_id != 6
                            && article.post_type_id != 4
                            && path[0] != 'happynesttv'
                            && path[0] != 'kho-360'
                            && article.post_type != 'video'
                            && typeArticle !== 'cho-do-cu')
                        && <div className="thumbDetail wrap-next-image">
                            <img alt="" src={article.images?.data[0].storage_url}/>
                        </div>
                    }
                    <div className={"photoStoreDetail"}>
                        {
                            (article.post_type_label != 'Thảo luận' && article.post_type_id != 4)
                            && <div className="photoStoreDetail-head">
                                <div className="photoStore-head">
                                    <div className="photoStore-head__item wrap-next-image-not-crop">
                                        <img alt="" src={article.user?.avatar || '/images/icon-app.svg'}/>
                                    </div>
                                    <div className="photoStore-head__text">
                                        <a href={`/thanh-vien/u/${article?.user?.id}?t=tong-quan`}>
                                            <p className="tlt">{article.user?.display_name}</p>
                                            {(article.user?.is_professional || article.user?.id == 18) &&
                                                <p className="lable">{article.user?.infoProfessional}</p>}
                                        </a>
                                    </div>
                                </div>
                                {stateStore.profileCommunity?.id !== article?.user?.id &&
                                    <button className="btn btn--blue" onClick={handleTheoDoi}>
                                        {theoDoi
                                            ? <>Đang theo dõi</>
                                            : <><span><img alt="" src="/images/icon-plusWhite.svg"/></span>Theo dõi</>}
                                    </button>
                                }
                            </div>
                        }
                        {article.post_type_id != 3 && article.post_type_id != 6 && article.post_type_id != 4 &&
                            <ul className="photoStore-item">
                                {
                                    (article.terms?.data || []).map((tag, index) => {
                                        return (<li key={index}>{tag?.name}</li>);
                                    })
                                }
                            </ul>}
                        {article.reviewer_type !== 0 && article.reviewer_type == 1 && genReviewChuyenGia()}

                        {article.reviewer_type !== 0 && article.reviewer_type == 2 && genReviewSanPham()}

                        <h1 className={(article.post_type_id != 3 && article.post_type_id != 6 && article.post_type_id != 4) ? "photoStoreDetail-title" : "photoStoreDetail-title mt-0"}>{article.title}</h1>
                        <div className="photoStore-post">
                            {article.published_at_detail_formatted &&
                                <span>Cập nhật ngày {article.published_at_detail_formatted}</span>}
                            <span><img alt=""
                                src="/images/icon-view.svg"/>{numberWithCommas(article.interaction_count?.view_count_number || 0)} lượt xem</span>
                        </div>

                        <ArticleInfo articleInformation={article.information}/>

                        {article.professional?.data && <ProfessionalInfo item={article.professional.data}/>}

                        {(article.post_type_id != 3 && article.post_type_id != 6) &&
                            <div className="old-format article-content mt-3">
                                {createMarkup1()}
                            </div>}
                        {(article.post_type_id == 3 || article.post_type_id == 6) &&
                            <div className={"old-format article-content mt-3 " + (seeMore ? "no-hidden" : "hiden")}
                                style={{transition: 'transform ease-out 0.3s'}}>
                                {createMarkup1()}
                                {
                                    !seeMore && <button className="btn btn--blue btn-readmore"
                                        onClick={() => setSeeMore(!seeMore)}>Xem thêm
                                        <img src="/images/icon-arrow-down.svg" align="" alt="" className="ml-1"/>
                                    </button>
                                }
                                {
                                    seeMore &&
                                    <div className='text-center cursor-pointer' onClick={() => setSeeMore(!seeMore)}>
                                        <div style={{width: 'calc(50% - 70px)', display: 'inline-block'}}>
                                            <hr/>
                                        </div>
                                        <button
                                            className="btn"
                                            style={{position: 'unset', color: '#AAA'}}
                                        >Thu gọn
                                        </button>
                                        <div style={{width: 'calc(50% - 70px)', display: 'inline-block'}}>
                                            <hr/>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        {
                            article.is_livestream && <div className="iframe-fb">
                                {createMarkup2()}
                            </div>
                        }
                        {
                            <Kho360 information={information}/>
                        }
                        {
                            (article.post_type_id == 3 || article.post_type_id == 6) &&
                            <div className="old-format article-content mt-3">
                                {
                                    (!isEmpty(article.photos?.data)
                                        ? article.photos.data.map((photo) => {
                                            const image = article.images?.data.find(x => x.id == photo.thumbnail_file_id);
                                            return image && {...photo, ...image};
                                        })
                                        : article.images?.data
                                    )
                                        .map((item, index) => {
                                            if (!item) return <></>;
                                            return <div key={index} className="createPost-thumb">
                                                <div className="thumb sliderPhoto" style={{position: 'relative'}}>
                                                    <ImageComponentWithTag key={index} image={item} isOwn={isOwn}/>
                                                </div>
                                            </div>;
                                        })
                                }
                            </div>
                        }

                        {
                            (typeArticle === 'cho-do-cu' || article.post_type_id == 4) &&
                            <div className="old-format mt-3">
                                {
                                    !isEmpty(article?.images?.data)
                                        ? (article?.images?.data).map((item, index) => {
                                            if (article.content.indexOf(item.storage_url) > -1) return <></>;
                                            return <div key={index} className="createPost-thumb mt-4">
                                                <div className="thumb sliderPhoto" style={{position: 'relative'}}>
                                                    <div className="photoGallery-large mt-4">
                                                        <img src={item.storage_url} alt=""/>
                                                    </div>
                                                </div>
                                            </div>;
                                        })
                                        : (
                                            <div className="thumb sliderPhoto" style={{position: 'relative'}}>
                                                <img alt="" src={article.storage_thumbnail_url_large}/>
                                            </div>
                                        )
                                }
                            </div>
                        }

                        {!isEmpty(article.tags?.data) && <ul className="photoStore-item mb-2">
                            {
                                (article.tags?.data || []).map((tag, index) => {
                                    return (<li key={index}><a href={`/hashtag/${tag.id}/${tag.slug}`}
                                        className="c-blue">#{tag.name}</a></li>);
                                })
                            }
                        </ul>}

                        <Poll pollData={article.poll} user={stateStore.profileCommunity}></Poll>

                        {
                            (article.post_type_id != 3 && article.post_type_id != 6) && authorHorizon
                        }

                        {
                            (article.is_consulting) && <FormDangKyTuVan
                                style={{marginTop: 24}}
                                article={article}
                                chuyenGia={article.consultant_id ? {
                                    id: article.consultant_id,
                                    display_name: article.consultant_name
                                } : null}
                                source={5}
                            />
                        }

                        <Comment article={article} slug={slug}/>

                        <SliderAd positionDesktop="2" pageDesktop="59" positionMobile="6" pageMobile="59"/>

                        {isEmpty(article?.site_mini_categories) &&
                            !isEmpty(article.related_posts?.data) &&
                            <>
                                <div className="groupCategory-title">
                                    <h2 className="groupCategory-tlt">Bài đăng liên quan</h2>
                                </div>
                                {typeArticle != 'kho-360' && <div className="relatedPost">
                                    <ul>
                                        {
                                            article.related_posts.data.map((item, index) => (
                                                <li key={index}>
                                                    <RelatedPost item={item} slug={typeArticle}/>
                                                </li>))
                                        }
                                    </ul>
                                </div>}
                                {typeArticle == 'kho-360' && <div key="kho-360" className="lstPhoto category-list">
                                    <Slide items={
                                        article.related_posts.data.map((item, index) => {
                                            return <Detail360 key={index} item={item} index={index} isSlide={true}/>;
                                        })
                                    } slidesToShow={4} className="mt-3"/>
                                </div>}
                            </>
                        }
                        {!isEmpty(article?.ads_site_mini) &&
                            <SliderAd
                                positionDesktop={article?.ads_site_mini.detail.desktop.position_id}
                                pageDesktop={article?.ads_site_mini.detail.desktop.id}
                                positionMobile={article?.ads_site_mini.detail.mobile.position_id}
                                pageMobile={article?.ads_site_mini.detail.mobile.id}/>
                        }
                        {
                            !isEmpty(article?.site_mini_categories) &&
                            (article?.site_mini_categories || []).map((category, index) => {
                                return (
                                    <>
                                        <div className="groupCategory-title">
                                            <h2 className="groupCategory-tlt">{category.name}</h2>
                                        </div>
                                        {<div className="relatedPost">
                                            <ul>
                                                {
                                                    category.articles.map((item, index) => (
                                                        <li key={index}>
                                                            <RelatedPost item={item} slug={category.slug}/>
                                                        </li>))
                                                }
                                            </ul>
                                        </div>}
                                    </>
                                );
                            })
                        }
                        {isEmpty(article?.site_mini_categories) && (article?.categories || []).map((category, index) => {
                            return renderByType(category);
                        })}
                        {/* <div className="groupCategory-title">
                            <h2 className="groupCategory-tlt">Sản phẩm bán chạy</h2>
                            <a href="/shop/danh-muc" className="readMore">Xem tất cả</a>
                        </div>
                        <div className="lstPhoto lstProduct">
                            <ul>
                                {hotProduct.map((item, index) => (
                                    <li key={`${item.sku}` + index}>
                                        <Product item={item} index={index + 1}></Product>
                                    </li>
                                ))}
                            </ul>
                        </div> */}

                        {toolView}
                    </div>
                </div>
                <SliderAd positionMobile="25" pageMobile="59" isFix={true}/>
            </section>}
        </>
    );
};

export const getServerSideProps = async (context) => {
    console.log("getServerSideProps.........");
    const { params, query, res } = context;
    const isGooglebot = /Googlebot/.test(context.req.headers['user-agent']);
    console.log(isGooglebot);
    const articleSSG = await fetchArticleSsr(contentType(params.id[0]), params.id[1], query,"/preview");
    if (articleSSG === null) {
        return {
            notFound: true,  // Nếu không tìm thấy dữ liệu
        };
    }
    if(articleSSG.status_code !== 1){
        return {
            notFound: true,  // Nếu không tìm thấy dữ liệu
        };
    }
    const slugCategory = renderTypePost(params.id[0]);
    const slugArticle = typeof params.id[2] !== "undefined"?params.id[2]: "";
    if(articleSSG.first_term === null){
        return {
            props: {
                article: articleSSG || {},
                path: params.id,
            },
        };
    }
    let slugCategorySSR = articleSSG.first_term?.slug;

    if(articleSSG.first_term?.parent_id > 0){
        slugCategorySSR = getTypeArticle(articleSSG);
    }
    if(slugCategorySSR === "kho-anh"){
        slugCategorySSR = "album";
    }
    if (slugCategorySSR === "eMagazine" || slugCategorySSR === "emagazine") {
        slugCategorySSR =  "happynest-story";
    }
    if(slugCategorySSR === "thread"){
        slugCategorySSR = "thao-luan";
    }
    if(typeof (slugCategorySSR) === "undefined"){
        slugCategorySSR = slugCategory;
    }
    if (slugCategory === slugCategorySSR) {
        return {
            props: {
                article: articleSSG || {},
                path: params.id,
            },
        };
    }

    let seoUrl = DOMAIN_HAPPYNEST + slugCategorySSR + '/' + articleSSG.id + '/' + articleSSG.slug;
    console.log(slugCategory,slugCategorySSR);
    if (slugCategory !== slugCategorySSR || !inArraySlug(slugCategory)) {
        return {
            redirect: {
                destination: seoUrl,
                permanent: true,
            },
        };
    }
    if(slugArticle !== articleSSG.slug){
        return {
            redirect: {
                destination: seoUrl,
                permanent: true,
            },
        };
    }
    return {
        props: {
            article: articleSSG || {},
            path: params.id,
        },
    };
    // Nếu không phải môi trường staging
    // if (!isStaging) {
    //     console.log("getServerSideProps isStaging.........");
    //     const apiRes = await http(`community/${contentType(params.id[0])}/${params.id[1]}/preview`, {}, {}, 'v2');
    //     if (apiRes.success === false || apiRes.data?.status_code !== 1) {
    //         return {
    //             notFound: true,  // Nếu không tìm thấy dữ liệu
    //         };
    //     }
    //
    //     return {
    //         props: {
    //             article: apiRes.data || {},
    //             path: params.id,
    //         },
    //     };
    // } else {
    //
    // }
};


export const fetchArticleSsr = async (slug,idArticle,query, addPreview="") => {
    try {
        let url = `community/${slug}/${idArticle}${addPreview}`;
        if (!isEmpty(query) && typeof query.site_url != "undefined") {
            url = `community/${slug}/${idArticle}${addPreview}?site_url=${query.site_url}`;
        }

        const res1 = await http(url, {}, {token: "Bearer " + getCookie(TOKEN_CONGDONG)}, 'v2');
        if (res1.code === 200) {
            return res1.data;
        }
        return null;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export function Kho360({information}) {
    const link360 = information.link_360;

    if (!link360) return <></>;

    return <iframe src={link360} allowFullScreen={true} width="100%" height={480}></iframe>;
}

export function DownloadFile({text, id}) {
    const router = useRouter();
    const ref = useRef(null);
    const [loading, setLoading] = useState(false);
    const handleOk = () => {
        router.push(`/login?redirect=${router.asPath}`);
    };

    const actionDownload = async () => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            Modal.confirm({
                // title: "Thông báo",
                content: "Hãy đăng nhập để xem và tải file",
                okText: "Đi tới đăng nhập",
                cancelText: "Hủy",
                onOk: handleOk,
                centered: true,
                width:300,
                className : "modal-confirm-login"
            });
            return;
        } else {
            setLoading(true);
            try {
                const idFile = id.slice(1);
                const res = await http(`community/file/get-link`, {}, {
                    body: {id: `${idFile}`},
                    method: 'POST',
                    token: "Bearer " + getCookie(TOKEN_CONGDONG)
                }, 'v2');
                const link = res.data.link_download;
                const fileName = res.data.file.name;
                if (link) {
                    const fileResponse = await fetch(link);
                    const blob = await fileResponse.blob();
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                }
            } catch (e) {
                Modal.error({
                    title: 'Đã xảy ra lỗi',
                    content: 'Vui lòng thử lại sau.',
                });
            } finally {
                setLoading(false);
            }
        }
    };

    return <>
        <span onClick={actionDownload} style={{color: '#34beef'}} className='cursor-pointer'>
            {text}
        </span>
        <Loader loading={loading}/>
    </>;
};